
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { TObjectDocument, ToyDocument } from "@/models/tobject.model";
import ScreenCanvas from "@/components/stead/store/screens/ScreenCanvas.vue";
import SbDetailsParameter from "@/components/stead/workspaces/stepbuilder/sbDetailsParameter.vue";
import { ParamValueDocument } from "@/models/parameter.model";
import VcardTextAjustHeight from "@/components/shared/VcardTextAjustHeight.vue";
import SbToyScreen from "@/components/stead/workspaces/stepbuilder/sbToyScreen.vue";
import { JisonParser } from "@/shared/jison/jison.parser";
import { payloadStep } from "@/store/stead/step.store";

@Component({
  components: {SbToyScreen, VcardTextAjustHeight, SbDetailsParameter, ScreenCanvas}
})
export default class SbInsertStep extends Vue {
  // Les props
  @Prop({default: ''}) private tcid!: string
  @Prop({default: null}) private insertData!: { pos: number, tobj: TObjectDocument } | null

  // Les propriétés
  private saving: boolean = false
  private instrucId: string = ''
  private updatedParams: ParamValueDocument[] = []
  private msgSnackbar: string = ''
  private showSnackbar: boolean = false

  // Les propriétés calculées
  private get tobject() {
    return this.insertData ? this.insertData.tobj : null
  }

  private get pos() {
    return this.insertData ? this.insertData.pos : 0
  }

  private get aToy() {
    return this.tobject && this.tobject.kind === 'Toy' ? this.tobject as ToyDocument : null
  }

  private get instructions() {
    return this.tobject ? this.tobject.type.instructions : []
  }

  private get instrucDoc() {
    const instruc = this.instructions.find(i => i._id === this.instrucId)
    return instruc ? instruc.documentation : ''
  }

  private get instrucParams() {
    const instruc = this.instructions.find(i => i._id === this.instrucId)
    return instruc ? instruc.parameters.sort((p1, p2) => p1.pos - p2.pos) : []
  }

  // Les hooks
  // Les méthodes surveillées
  @Watch('instrucId')
  private onChangeInstruction() {
    this.updatedParams = this.instrucParams.map<ParamValueDocument>(pd => {
      return {descId: pd, value: ''}
    })
  }

  // Les méthodes d'instance
  private async onSaveChanges() {
    if (this.isEligible() && this.tobject) {
      const payload = {
        tcid: this.tcid,
        pos: this.pos,
        steps: {
          instruc: this.instrucId,
          tobject: this.tobject._id,
          parameters: this.updatedParams.map((pvd) => {
            return {
              descId: pvd.descId._id,
              value: pvd.value
            }
          })
        }
      } as payloadStep
      this.saving = true
      await this.$store.dispatch('step/insertStep', payload)
      this.$emit('inserted')
      this.saving = false
    }
  }

  /**
   * Checks if all the required parameters are filled and if all the parameters have a correct syntax
   */
  private isEligible(): boolean {
    let flag: boolean = false
    if (!this.instrucId || this.instrucId.length === 0) {
      this.msgSnackbar = 'No instruction selected'
      this.showSnackbar = true
      return false
    }
    this.updatedParams.forEach((pvd: ParamValueDocument) => {
      if (pvd.value.length === 0 && pvd.descId.required) {
        flag = true
      }
    })
    if (flag) {
      this.msgSnackbar = 'Required parameters must be entered before saving changes'
      this.showSnackbar = true
      return false
    }
    this.updatedParams.forEach((pvd: ParamValueDocument) => {
      if (pvd.value.length > 0) {
        const parser = JisonParser.builder(pvd.descId)
        if (parser && typeof parser.exec(pvd.value) === 'string') {
          flag = true
          // console.log(`syntaxe error sur ${pvd.descId.label} = ${pvd.value}`)
        }
      }
    })
    if (flag) {
      this.msgSnackbar = 'Syntax error on one or more parameters'
      this.showSnackbar = true
      return false
    }
    return true
  }


  // Les méthodes statiques
}
